<script lang="ts">
  import { t } from "../../../core";
  import ChangePasswordForm from "./components/ChangePasswordForm.svelte";
</script>

<svelte:head>
  <title>{t("ResetPassword.General.Title")}</title>
</svelte:head>

<ChangePasswordForm
  title={t("ResetPassword.Form.Title")}
  description={t("ResetPassword.Form.Description")}
  submit={t("ResetPassword.Form.SubmitButton")}
  endpoint="/api/Customer/resetPassword"
/>
